// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pidgeot_mega: PokeData = {
  "id": 10073,
  "name": "pidgeot-mega",
  "height": 22,
  "weight": 505,
  "base_experience": 261,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "razor-wind",
    "gust",
    "wing-attack",
    "whirlwind",
    "sand-attack",
    "tackle",
    "agility",
    "quick-attack",
    "mirror-move",
    "sky-attack",
    "twister",
    "heat-wave",
    "feather-dance",
    "roost",
    "tailwind",
    "air-slash",
    "hurricane"
  ],
  "moves": [
    "gust",
    "tackle",
    "quick-attack",
    "sky-attack",
    "roost",
    "tailwind",
    "air-slash",
    "hurricane",
    "leer",
    "scratch",
    "headbutt",
    "growl",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 6,
    "item": null,
    "species": [
      {
        "name": "pidgey",
        "order": 16,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pidgeotto",
        "order": 17,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 16,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "pidgeot",
        "order": 18,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 17,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 97,
    "speed": 143,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
